import {
  OMOP_ETL_RUN_REQUEST,
  OMOP_ETL_RUN_SUCCESS,
  OMOP_ETL_RUN_FAIL,
  OMOP_ETL_RUN_RESET,
} from '../constants/omopConstants';

export const omopEtlRunReducer = (state = {}, action) => {
  switch (action.type) {
    case OMOP_ETL_RUN_REQUEST:
      return { loading: true };
    case OMOP_ETL_RUN_SUCCESS:
      return { loading: false, success: true, result: action.payload };
    case OMOP_ETL_RUN_FAIL:
      return { loading: false, error: action.payload };
    case OMOP_ETL_RUN_RESET:
      return {};
    default:
      return state;
  }
};
